import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { RestfulService } from 'src-ironside/services/restful.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LanguageProperty } from './product.repository';

export type ResourceFile = {
    id: string;
    name: string;
    url: string;
    thumbnailUrl: string;
};

export type Resource = {
    id: string;
    creationDate: number;
    updatingDate: number;
    files: ResourceFile[];
    title: string;
    typeOfResource: string;
    linkToProduct: string;
    urlYoutube?: string;
    status?: any;
    referential?: string;
    typeOfResourceLabel?: LanguageProperty;
};

@Injectable({ providedIn: 'root' })
export class ResourceRepository extends RestfulService {
    constructor(public override httpClient: HttpClient, public override router: Router) {
        super(httpClient, router);
    }
    findByIds(ids: string[], showLoading = true): Observable<Resource[]> {
        if (ids.length === 0) {
            return of([]);
        }
        return this.doPost(`view/filtrerById/dynamic_ressource`, ids, '', showLoading).pipe(
            map((res) => {
                const results: Resource[] = [];
                for (const resource of res?.response) {
                    if (resource) {
                        results.push({
                            id: resource?.id,
                            title: resource?.title,
                            creationDate: resource?.creationDate,
                            updatingDate: resource?.updatingDate,
                            files: resource?.file?.map((item: any) => ({
                                id: item.resourceFileId,
                                name: item.name,
                                url: item.url,
                                thumbnailUrl: item?.thumbnailUrl,
                            })),
                            typeOfResource: resource?.typeOfResource?.value,
                            linkToProduct: resource?.linkToProduct?.map((el: any) => el.documentId),
                            urlYoutube: resource?.urlYoutube,
                            status: resource?.status,
                            referential: resource?.linkToProduct?.[0]?.value,
                            typeOfResourceLabel: resource?.typeOfResource?.labels,
                        });
                    }
                }
                return results;
            })
        );
    }

    getFirstImageResource(resourceIds?: string[]): Observable<string | undefined> {
        if (!resourceIds || resourceIds.length === 0) {
            return of(undefined);
        }

        // return this.findByIds(resourceIds).pipe(
        //     map((resource) => {
        //         for (let i = 0; i < resource.length; i++) {
        //             for (let j = 0; j < resource[i].files?.length; j++) {
        //                 const file = resource[i].files[j];
        //                 if (!file.name?.endsWith('pdf')) {
        //                     return file.url;
        //                 }
        //             }
        //         }
        //         return undefined;
        //     })
        // );

        return this.findByIds(resourceIds, false).pipe(
            map((resource) => {
                const firstPhotoMapping = resource.find((item) => item.typeOfResource === 'PHOTO');

                if (firstPhotoMapping) {
                    return firstPhotoMapping.files[0].url;
                }

                return undefined;
            })
        );
    }

    getListImageResource(resourceIds?: string[]) {
        return resourceIds && resourceIds.length > 0
            ? this.findByIds(resourceIds).pipe(
                  map((resource) => resource.filter((item) => item.typeOfResource === 'PHOTO'))
              )
            : of(undefined);
    }

    getListImageResourceMultil(resourceIds?: string[]) {
        return resourceIds && resourceIds.length > 0
            ? this.findByIds(resourceIds, false).pipe(
                  map((resource) => resource.filter((item) => (item?.urlYoutube?.length ?? 0) <= 0))
              )
            : of(undefined);
    }

    getDynamicResource(data: any, isLoading: boolean): Observable<any> {
        return this.doPost('dynamic-documents/dynamic_ressource/search', data, '', isLoading);
    }
}
